import { useCallback } from "react";
import "./service-panel.scss";
import { useTransactionStepContext } from "../transaction-step.context";
import FormTransactionServiceWrapper from "@domain/transaction-service/form-transaction-service-wrapper/form-transaction-service-wrapper";
import { Button } from "primereact/button";
import { useNewTransactionContext } from "../new-transaction.context";
import { LabelValue } from "@shared/models/label-value.interface";

export function ServicePanel() {
  const { isCreating } = useNewTransactionContext();
  const {
    isParentAndChild,
    serviceFormRef,
    selectedChildren,
    childrenList,
    childFirstList,
    selectedMember,
    memberList,
    handleServiceForm,
    previousStepper,
    handleServiceTrigger,
    nextStepper,
    isCreateNewChild,
    childFormData,
    serviceFormData,
  } = useTransactionStepContext();

  const handleNext = async () => {
    const isValid = await handleServiceTrigger();
    if (isValid) {
      nextStepper();
    }
  };

  const displayServiceForms = useCallback(() => {
    if (isParentAndChild) {
      // Parent-Child flow: Show services for selected children
      let childrenData: any[];
      if (isCreateNewChild) {
        childrenData = childFormData.map((child, index) => {
          const name = `${child.firstName || ""} ${child.lastName || ""}`.trim() || `Child #${index + 1}`;
          return new LabelValue(name, `new-${index}`, child);
        });
      } else {
        childrenData = selectedChildren.map((item) =>
          childrenList.find((x) => x.value === item) || childFirstList.find((x) => x.value === item)
        ).filter(Boolean) as any[];
      }

      if (childrenData.length === 0) return <div>Loading children data...</div>;

      return childrenData.map((item, id) => (
        <div key={id} className="border border-dashed p-4">
          <FormTransactionServiceWrapper
            member={item}
            hideAdvanceBooking={true}
            ref={(el) => {
              serviceFormRef.current[id] = el!;
            }}
            defaultValues={serviceFormData[id]}
            onChange={(data) => handleServiceForm(data, id)}
            onSubmit={(data) => handleServiceForm(data, id)}
          />
        </div>
      ));
    } else {
      // Individual Member flow: Show service for selected member
      const memberData = memberList.find((x) => x.value === selectedMember);

      if (!memberData) return <div>Please select a member first...</div>;

      return (
        <div className="border border-dashed p-4">
          <FormTransactionServiceWrapper
            member={memberData}
            hideAdvanceBooking={true}
            ref={(el) => {
              serviceFormRef.current[0] = el!;
            }}
            defaultValues={serviceFormData[0]}
            onChange={(data) => handleServiceForm(data, 0)}
            onSubmit={(data) => handleServiceForm(data, 0)}
          />
        </div>
      );
    }
  }, [
    isParentAndChild,
    selectedChildren,
    childrenList,
    childFirstList,
    selectedMember,
    memberList,
    serviceFormRef,
    handleServiceForm,
    isCreateNewChild,
    childFormData,
  ]);

  return (
    <div id="ServicePanel" className="service-panel">
      <div className="flex flex-col h-12rem">
        <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
          {displayServiceForms()}
        </section>
      </div>
      <div className="flex pt-4 justify-between">
        <Button
          label="Back"
          severity="success"
          outlined
          icon="pi pi-arrow-left"
          onClick={() => previousStepper()}
        />
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          disabled={isCreating}
          onClick={handleNext}
        />
      </div>
    </div>
  );
}

export default ServicePanel;
